// import external dependencies
import 'jquery';
import 'jquery-match-height/dist/jquery.matchHeight-min';
import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'slick-carousel/slick/slick.min';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min';
import 'inputmask/dist/jquery.inputmask';

// Import everything from autoload


import './dropdown';
import './sticky-footer';
import './accordion';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
